export default __webpack_public_path__ + "static/media/class_x_engg_m.ea65664c.png";